import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';

import { Observable, of, throwError } from 'rxjs';

import { catchError, map } from 'rxjs/operators';

import {
  AnimalGroup,
  AnimalGroupsResponse,
  UpsertAnimalGroupResponse,
} from '../models/animal-group.model';

@Injectable({
  providedIn: 'root',
})
export class AnimalGroupService {
  private baseUrl = `${this.env.API_BASE_URL}/service/pig-registration/secure/animalgroup`;

  constructor(
    private readonly http: HttpClient,
    @Inject(EnvironmentInjector) private readonly env: { API_BASE_URL: string },
  ) {}

  // get animalgroups
  getAnimalGroups(): Observable<AnimalGroup[] | HttpErrorResponse> {
    return this.http.get<AnimalGroupsResponse>(`${this.baseUrl}`, {}).pipe(
      map((response) => response.animalGroups),
      catchError((error: HttpErrorResponse) => {
        if (error.status === 404) {
          return of(<AnimalGroup[]>[]);
        } else {
          return throwError({ message: error.message });
        }
      }),
    );
  }

  // post animalGroups
  upsertAnimalGroup(
    animalGroup: AnimalGroup,
  ): Observable<UpsertAnimalGroupResponse | HttpErrorResponse> {
    return this.http
      .post<UpsertAnimalGroupResponse>(`${this.baseUrl}`, { ...animalGroup }, {})
      .pipe(
        map((d) => d),
        catchError((error: HttpErrorResponse) => {
          if (error.status === 404) {
            return of(<UpsertAnimalGroupResponse>{});
          } else {
            return throwError({ message: error.message });
          }
        }),
      );
  }

  // delete animalGroup
  deleteAnimalGroup(id: number) {
    return this.http.delete(`${this.baseUrl}/${id}`);
  }
}
